import { useUserData } from 'core/Api';
import { ShareModal } from 'core/Components';
import { Route, Routes, useNavigate } from 'react-router-dom';

export const overlayRoutes = ['/share'];

// These are routes that are overtop of all other routes. This should be used for things like modals that have their own route.
export const OverLayRoutes = () => {
  const navigate = useNavigate();
  const { data: user } = useUserData();

  if (!user?.referral_url) return null;

  return (
    <Routes>
      <Route
        path="/share"
        element={
          <ShareModal
            opened
            onClose={() => navigate('/offers')}
            link={user?.referral_url}
            causeName={user?.cause?.name}
            imgSrc={user?.cause?.logo?.url}
          />
        }
      />
    </Routes>
  );
};
